<template>
  <el-popover placement="top-start" width="160" trigger="hover">
    <ul class="opt-ul">
      <li @click="toLogout">退出登录</li>
    </ul>
    <section slot="reference">
      <section class="User">
        <img class="img" :src="photo || defaultPhoto" alt="头像" />
        <span class="name">{{ currentUser.username }}</span>
      </section>
    </section>
  </el-popover>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import defaultPhoto from '@/assets/img/defaultPhoto.png'
import { filePreviewApi } from '@/api/serviceEip'

export default {
  name: 'User',
  data() {
    return {
      defaultPhoto,
      photo: null
    }
  },
  computed: {
    ...mapState('sys', ['currentUser', 'currentUserDetail'])
  },
  created() {
    this.getPhoto()
  },
  methods: {
    ...mapActions('sys', ['toLogout']),
    async getPhoto() {
      const self = this
      const res = await filePreviewApi({
        fileId: this.currentUserDetail.user.photo
      })
      const reader = new FileReader()
      reader.readAsDataURL(res)
      reader.onload = function (e) {
        self.photo = e.target.result
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.User {
  display: flex;
  align-items: center;
}
.img {
  border: 1px solid #fff;
  margin-right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.name {
  color: #fff;
  font-size: 12px;
}
.opt-ul {
  > li {
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background-color: #ebf0ff;
    }
  }
}
</style>
